export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/galleryIcon.bfd743b9.svg","height":16,"width":15,"blurWidth":0,"blurHeight":0};